"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableScrollTillPresent = exports.waitTillExists = exports.shouldBeRendered = exports.getEnvironment = exports.acknowledged = exports.acknowledge = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const constants_1 = require("./constants");
const acknowledge = () => {
    const domain = window.location.hostname.split('.').splice(1).join('.');
    js_cookie_1.default.set(constants_1.CRM_COOKIES_CONSENT_KEY, 'true', {
        domain,
        path: '/',
        expires: 3650, // 10 years in days
    });
};
exports.acknowledge = acknowledge;
const acknowledged = () => js_cookie_1.default.get(constants_1.CRM_COOKIES_CONSENT_KEY) !== undefined;
exports.acknowledged = acknowledged;
const getEnvironment = () => window.location.href.search(/(-pp(1|2|3))|(localhost)/) === -1 ? 'prod' : 'nonprod';
exports.getEnvironment = getEnvironment;
const shouldBeRendered = () => {
    const deviceDetectionCookie = js_cookie_1.default.get('wh_device');
    if (!deviceDetectionCookie) {
        return true; // rendering cookie banner if failed to detect device
    }
    try {
        const deviceInfo = JSON.parse(deviceDetectionCookie);
        // not rendering on ios native app v10+
        return !(deviceInfo.is_native === true && deviceInfo.device_os === 'ios' && deviceInfo.app_version >= 10);
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        return true; // rendering cookie banner if failed to parse wh_device cookie
    }
};
exports.shouldBeRendered = shouldBeRendered;
const waitTillExists = (element) => {
    return new Promise((resolve) => {
        const domObserver = new MutationObserver((mutationList, obsever) => {
            mutationList.forEach((mutation) => {
                const exists = !![...mutation.removedNodes].find((node) => node === element);
                if (exists) {
                    obsever.disconnect();
                    resolve();
                }
            });
        });
        domObserver.observe(document.body, {
            childList: true,
        });
    });
};
exports.waitTillExists = waitTillExists;
const disableScrollTillPresent = (rootElement) => __awaiter(void 0, void 0, void 0, function* () {
    const NO_SCROLL_CLASSNAME = 'body-no-scroll';
    document.body.classList.add(NO_SCROLL_CLASSNAME);
    yield (0, exports.waitTillExists)(rootElement);
    document.body.classList.remove(NO_SCROLL_CLASSNAME);
});
exports.disableScrollTillPresent = disableScrollTillPresent;
